import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { AngularFireModule } from 'angularfire2';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { BlockUIModule } from 'ng-block-ui';
import {
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
} from '@angular/material';

import { SafePipeModule } from 'safe-pipe';

import { environment } from '../environments/environment';

import { SocialLoginModule, AuthServiceConfig } from 'angular5-social-login';
import { FacebookLoginProvider, GoogleLoginProvider } from 'angular5-social-login';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { RoleGuardService } from './services/role-guard.service';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask/src/currency-mask.config';
import { ClientInterceptor } from './@core/interceptors/client-interceptor';
export function getAuthServiceConfigs() {
    const config = new AuthServiceConfig([
        {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('214373356016835')
        },
        {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider('690940757822-jrr093pf2qieg1rd27erh5kqokp2kcun.apps.googleusercontent.com')
        }
    ]);
    return config;
}


import { AppComponent } from './app.component';

import { SharedModule } from './shared/shared.module';
import { AuthComponent } from './auth/auth.component';
import { PublicComponent } from './public/public.component';
import { TutorPanelComponent } from './tutor-panel/tutor-panel.component';

import { VisualizadorComponent } from './modules/visualizador/visualizador.component';

import { AppRoutes } from './app.routing';

// call translation root
import { TranslateSharedModule } from './translate/translate.module';
import { TutorService } from './services/tutor/tutor.service';
import { GlobalService } from './services/global.service';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: 'left',
    allowNegative: false,
    allowZero: true,
    decimal: ',',
    precision: 2,
    prefix: 'R$ ',
    suffix: '',
    thousands: '.'
};

@NgModule({
    exports: [
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatStepperModule,
        FroalaEditorModule,
        FroalaViewModule
    ]
})
export class MaterialModule { }

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        RouterModule.forRoot(AppRoutes),
        HttpModule,
        MaterialModule,
        SharedModule,
        HttpClientModule,
        CurrencyMaskModule,
        SafePipeModule,
        TranslateSharedModule,
        BlockUIModule.forRoot(),
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireStorageModule,
        AngularFirestoreModule,
    ],
    declarations: [
        AppComponent,
        AuthComponent,
        PublicComponent,
        TutorPanelComponent,
        VisualizadorComponent
    ],
    exports: [
        MaterialModule,
        SharedModule,
        SafePipeModule
    ],
    providers: [
        GlobalService,
        AuthService,
        AuthGuardService,
        RoleGuardService,
        AuthService,
        TutorService,
        {
            provide: CURRENCY_MASK_CONFIG,
            useValue: CustomCurrencyMaskConfig
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ClientInterceptor,
            multi: true
        },
        {
            provide: AuthServiceConfig,
            useFactory: getAuthServiceConfigs
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(private authService: AuthService, private route: Router) {
        this.authService.syncActiveClient('23');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts